var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row container-gray pt-2 mt-3"},[_c('div',{staticClass:"col-12 overflow-hidden"},[_c('vue-form-generator',{key:_vm.vueFormGenbKey,class:'container-fluid p-0',attrs:{"schema":_vm.schema,"model":_vm.dynamicFormModel,"options":_vm.formOptions,"tag":"div"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }